<template>
    <!--********** FINESTRA MODALE **********-->
    <div class="modal is-active">
        <div class="modal-background"></div>
        <div class="modal-content">
            <article class="message">
                <div class="message-body">
                    <p class="has-text-centered">{{ props.confMessaggioModale.messaggio }}</p>
                    <p class="has-text-centered" v-if="props.confMessaggioModale.messaggio2"><br>{{ props.confMessaggioModale.messaggio2 }}</p>
                    <p v-if="props.confMessaggioModale.casellaTestoVisibile"><br></p>
                    <div class="field" v-if="props.confMessaggioModale.casellaTestoVisibile">
                        <div class="control">
                            <div class="columns">
                                <div class="column"> <input class="input" type="text" v-model="testoInserito"></div>
                            </div>
                        </div>
                    </div>
                    <p v-if="props.confMessaggioModale.download"><br></p>
                    <div v-if="props.confMessaggioModale.download">
                        <p class="has-text-centered" @click="bSeleziona(props.confMessaggioModale.download.comando)">
                            <a :href="props.confMessaggioModale.download.link" :download=props.confMessaggioModale.download.nomeFile>{{props.confMessaggioModale.download.nomeFile}}</a>
                        </p>
                    </div>
                    <p v-if="props.confMessaggioModale.download"><br></p>
                    <p><br></p>
                    <div class="buttons is-centered">
                        <button class="button" @click="bSeleziona(props.confMessaggioModale.testoLight.comando)" v-if="props.confMessaggioModale.testoLight != null">{{ props.confMessaggioModale.testoLight.testo }}</button>
                        <button class="button is-primary" @click="bSeleziona(props.confMessaggioModale.testoPrimary.comando)" v-if="props.confMessaggioModale.testoPrimary != null">{{ props.confMessaggioModale.testoPrimary.testo }}</button>
                        <button class="button is-danger" @click="bSeleziona(props.confMessaggioModale.testoDanger.comando)" v-if="props.confMessaggioModale.testoDanger != null">{{ props.confMessaggioModale.testoDanger.testo }}</button>
                    </div>
                </div>
            </article>
        </div>
    </div>
</template>

<script setup>
    import { defineProps, defineEmits, ref } from "vue";

    // PROPRIETA' ED EVENTI DEL COMPONENTE
    const props = defineProps({
        // Deve ricevere un oggetto del tipo:
        // { testoLight:{testo:'Annulla', comando:'annulla'},
        //    testoPrimary:null,
        //    testoDanger:{testo:'Chiudi senza salvare', comando:'chiudi'},
        //    messaggio:"Proseguendo perderai le modifiche fatte",
        //    messaggio2:"Seconda riga di messaggio",
        //    download:{link:JSonHtml, nomeFile:'contatto.csv', comando:'annulla'},
        //    casellaTestoVisibile:true }
        confMessaggioModale: {
            type: Object,
            default: () => {return null}
        }
    });
    const emit = defineEmits(['selezionato']);

    // VARIABILI DEL COMPONENTE
    const testoInserito = ref();

    // SETUP DEL COMPONENTE

    // FUNZIONI DEL COMPONENTE
    function bSeleziona(comando) {
        emit('selezionato', comando, testoInserito.value);
    }

</script>